import { courseServiceApi } from "../../apis/courseService.api";
import { COURSE_API_TAGS } from "../../app.constants";
import type {
  CheckWishlist,
  IAddWishlistDto,
  RemoveWishListParams,
  WishList,
  WishListParams,
} from "./wishlist.types";

export const orderService = courseServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    addWishlist: builder.mutation<unknown, IAddWishlistDto>({
      query: (body) => ({
        url: "/me/wishlist/items",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        COURSE_API_TAGS.WISHLIST,
        { type: COURSE_API_TAGS.WISHLIST, id: "CHECK" },
      ],
    }),

    getWishlist: builder.query<WishList, WishListParams>({
      query: (params) => ({
        url: "/me/wishlist",
        method: "GET",
        params,
      }),
      providesTags: [COURSE_API_TAGS.WISHLIST],
    }),

    removeWishlist: builder.mutation<unknown, RemoveWishListParams>({
      query: (params) => {
        const { courseUuid, ...rest } = params;
        return {
          url: `/me/wishlist/items/course/${courseUuid}`,
          method: "DELETE",
          params: rest,
        };
      },
      invalidatesTags: [
        COURSE_API_TAGS.WISHLIST,
        { type: COURSE_API_TAGS.WISHLIST, id: "CHECK" },
      ],
    }),

    getCheckWishlist: builder.query<CheckWishlist, RemoveWishListParams>({
      query: (params) => {
        const { courseUuid, ...rest } = params;

        return {
          url: `/me/wishlist/check/course/${courseUuid}`,
          method: "GET",
          params: rest,
        };
      },
      providesTags: [{ type: COURSE_API_TAGS.WISHLIST, id: "CHECK" }],
    }),
  }),
});

export const {
  useAddWishlistMutation,
  useGetWishlistQuery,
  useRemoveWishlistMutation,
  useGetCheckWishlistQuery,
} = orderService;
